var createTableResponsive = function (container) {
    $(container).each(function(){
        $(this).find('table').each(function () {
            var tableTitle = [];
            $(this).find('thead').first().find('tr th').each(function () {
                tableTitle.push($(this).text());
            });
            $(this).find('tbody').first().children().each(function () {
                for (var i = 0; i < $(this).children().length; i++) {
                    $(this).children().eq(i).attr('data-title', tableTitle[i]);
                }
            });
        });
    });
};

jQuery(document).ready(function($){
    createTableResponsive('.responsive-table,.page_content');
});